import EternaLifeLogo from '@/assets/logos/eterna-life.svg?react';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

interface HeaderWrapperProps {
  logoHref?: string;
  desktopContent?: React.ReactNode;
  mobileContent?: React.ReactNode;
}

export function HeaderWrapper({
  logoHref = routes.home,
  desktopContent,
  mobileContent,
}: HeaderWrapperProps) {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  const { isDesktop } = useBreakpoint();

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;

        if (currentScrollY < lastScrollY || currentScrollY < 10) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
        setIsScrolled(currentScrollY > 10);

        setLastScrollY(currentScrollY);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar);

      return () => {
        window.removeEventListener('scroll', controlNavbar);
      };
    }
  }, [lastScrollY]);

  return (
    <div className="h-25" aria-hidden="true" role="presentation">
      <nav
        className={cn(
          'bg-background fixed top-0 right-0 left-0 z-50 h-25 w-full px-4 py-7 transition-transform duration-300 ease-in-out lg:px-6',
          !isVisible && '-translate-y-full',
          isScrolled && 'bg-background/95',
        )}
      >
        <div className="mx-auto flex w-full max-w-305 items-center justify-between">
          <Link to={logoHref}>
            <EternaLifeLogo className="text-secondary h-8 w-41 shrink-0 lg:h-11 lg:w-57" />
          </Link>

          {/* Desktop content */}
          {isDesktop && desktopContent}

          {/* Mobile with drawer content */}
          {!isDesktop && (mobileContent || desktopContent)}
        </div>
      </nav>
    </div>
  );
}
